import type { MarkingCodeStatus } from "@/types/marking"
import { MARKING_CODE_STATUS_ITEMS } from "@/lib/marking/code-status"
import { cn } from "@/lib/utils"

const STATUS_CLASS: Record<MarkingCodeStatus, string> = {
  unknown: "bg-muted text-muted-foreground",
  free: "bg-info/15 text-info",
  in_circulation: "bg-success/15 text-success",
  sold: "bg-primary/20 text-foreground",
  transferred: "bg-warning/15 text-warning",
  damaged: "bg-destructive/15 text-destructive",
}

export function StatusBadge({ status }: { status: MarkingCodeStatus | string }) {
  const key = status as MarkingCodeStatus
  const label = MARKING_CODE_STATUS_ITEMS[key] ?? status
  const className = STATUS_CLASS[key] ?? "bg-muted text-muted-foreground"

  return (
    <span
      className={cn(
        "inline-flex rounded-md px-1.5 py-0.5 text-xs font-medium whitespace-nowrap",
        className,
      )}
    >
      {label}
    </span>
  )
}
